import KumosearchError from "./KumosearchError";

export default class RequestUnauthorized extends KumosearchError {}
